import React from 'react';
import { useLocation } from 'react-router-dom';

const PHONE = '+390578738346';
const PHONE_DISPLAY = '+39 0578 738346';

// Rotte "admin critiche" dove un click accidentale sul widget può causare confusione
// durante operazioni massive (merge, import, riconciliazione).
const HIDDEN_ROUTES = [
  '/riconciliazione',
  '/formazione/da-fare',
];

const WhatsAppButton = () => {
  const { pathname } = useLocation();
  const shouldHide = HIDDEN_ROUTES.some((p) => pathname.startsWith(p));
  if (shouldHide) return null;

  const cleanNumber = PHONE.replace(/[^\d]/g, '');
  const url = `https://wa.me/${cleanNumber}?text=${encodeURIComponent('Ciao Centro Sicurezza, ho bisogno di assistenza su SafetyDesk81.')}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-5 right-5 z-50 group flex items-center gap-3"
      aria-label={`Apri WhatsApp con ${PHONE_DISPLAY}`}
    >
      <span className="hidden md:flex items-center bg-white shadow-lg rounded-full px-3 py-1.5 text-xs font-semibold text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity">
        <span className="text-emerald-600 mr-1">●</span> Chatta su WhatsApp · {PHONE_DISPLAY}
      </span>
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebd5a] shadow-xl transition-transform hover:scale-110">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping" />
        <svg viewBox="0 0 32 32" className="w-7 h-7 text-white relative" fill="currentColor" aria-hidden="true">
          <path d="M16 0C7.16 0 0 7.16 0 16c0 2.82.74 5.46 2.04 7.74L0 32l8.5-2.22A15.9 15.9 0 0 0 16 32c8.84 0 16-7.16 16-16S24.84 0 16 0zm0 29.1c-2.5 0-4.86-.66-6.92-1.84l-.5-.3-5.04 1.32 1.34-4.9-.32-.5A13.1 13.1 0 1 1 16 29.1zm7.34-9.74c-.4-.2-2.36-1.16-2.72-1.3-.36-.14-.62-.2-.88.2-.26.4-1 1.3-1.24 1.56-.22.26-.46.3-.86.1-.4-.2-1.7-.62-3.24-2-1.2-1.06-2-2.38-2.24-2.78-.24-.4-.02-.62.18-.82.18-.18.4-.46.6-.7.2-.24.26-.4.4-.66.14-.26.06-.5-.04-.7-.1-.2-.88-2.12-1.2-2.9-.32-.76-.64-.66-.88-.66h-.74c-.26 0-.66.1-1 .5-.34.4-1.32 1.3-1.32 3.16 0 1.86 1.34 3.66 1.52 3.92.2.26 2.66 4.06 6.46 5.7.9.4 1.6.62 2.16.78.9.28 1.74.24 2.4.16.74-.12 2.28-.94 2.6-1.84.32-.9.32-1.66.22-1.82-.08-.16-.34-.26-.74-.46z"/>
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppButton;
